import { sanitizeUserName } from '../utils/security';
import { ORDER_CREATION_PERMISSION_DEFAULT } from '../constants/orderCreationPermission';

/**
 * Teknisyen oluşturma/güncelleme istek gövdesi (TP API ve AP createUser ortak alanlar)
 */
export const buildTechnicianUserPayload = (payload = {}, { requirePassword = false } = {}) => {
  const data = {};

  if (payload.kullaniciAdi !== undefined && payload.kullaniciAdi !== '') {
    data.kullaniciAdi = sanitizeUserName(payload.kullaniciAdi);
  }

  if (payload.sifre !== undefined && String(payload.sifre).trim() !== '') {
    data.sifre = String(payload.sifre).trim();
  } else if (requirePassword) {
    throw new Error('Şifre gereklidir');
  }

  if (payload.ad !== undefined) {
    const trimmed = payload.ad ? String(payload.ad).trim() : '';
    data.ad = trimmed === '' ? null : trimmed;
  }

  if (payload.soyad !== undefined) {
    const trimmed = payload.soyad ? String(payload.soyad).trim() : '';
    data.soyad = trimmed === '' ? null : trimmed;
  }

  if (payload.telefon !== undefined && payload.telefon !== '') {
    data.telefon = String(payload.telefon).trim();
  } else if (payload.telefon === '' || payload.telefon === null) {
    data.telefon = null;
  }

  if (payload.mail !== undefined && payload.mail !== '') {
    data.mail = String(payload.mail).trim().toLowerCase();
  }

  if (payload.aktif !== undefined) {
    data.aktif = Boolean(payload.aktif);
  }

  if (payload.orderCreationPermission !== undefined) {
    data.orderCreationPermission = payload.orderCreationPermission;
  } else if (requirePassword) {
    data.orderCreationPermission = ORDER_CREATION_PERMISSION_DEFAULT;
  }

  return data;
};
